// imports
import { useEffect, useState } from 'react';

// styles
import styles from './SearchPaginationItem.module.scss';
interface SearchPaginationItemProps {
  value: number;
  currentPage: number;
  onClick: (value: number) => void;
}
const SearchPaginationItem = (props: SearchPaginationItemProps) => {
  const {
    value,
    currentPage,
    onClick
  } = props;
  const [isSelected, setIsSelected] = useState(currentPage === value ? true : false);
  useEffect(() => {
    setIsSelected(currentPage === value ? true : false);
  }, [currentPage, value]);
  let buttonClassName = styles.search_pagination_list_item_button;
  if (isSelected) {
    buttonClassName += ` ${styles.search_pagination_list_item_button_selected}`;
  }
  return <li className={styles.search_pagination_list_item} data-sentry-component="SearchPaginationItem" data-sentry-source-file="SearchPaginationItem.tsx">
      <button onClick={e => onClick(value)} value={value} className={buttonClassName}>
        {value}
      </button>
    </li>;
};
export default SearchPaginationItem;